export default __webpack_public_path__ + "static/media/sampleImg_women.1f2eb027.png";